import { SpyneTrait } from 'spyne';

export class CodePlaygroundNavTraits extends SpyneTrait {
  constructor(context) {
    let traitPrefix = 'codePlaygroundNav$';
    super(context, traitPrefix);
  }


// Updates the currentExampleIndex based on a given methodName
  static codePlaygroundNav$OnExampleUpdated(e){
    const {methodName} = e.payload;

    this.props.currentExampleIndex = this.codePlaygroundNav$findExampleIndexByMethod(methodName)

    const hideBackBtn = this.props.currentExampleIndex === 0;
    const hideForwardBtn = this.props.currentExampleIndex === this.props.examplesArr.length-1;

    this.props.el$("#prev-example").toggleClass('disable-nav-btn', hideBackBtn);
    this.props.el$("#next-example").toggleClass('disable-nav-btn', hideForwardBtn);

   //console.log("METHOD IS ",{hideBackBtn, hideForwardBtn},this.props.examplesArr.length,this.props.currentExampleIndex)


  }

  static codePlaygroundNav$findExampleIndexByMethod(methodName, examplesArr=this.props.examplesArr) {
    return examplesArr.findIndex(example => example.methodName === methodName);
  }


  static codePlaygroundNav$UpdateExample(e, props=this.props){
    const {dirNum} = e.payload;
    const exampleIndex = this.props.currentExampleIndex+parseInt(dirNum);

    const example = this.props.examplesArr[exampleIndex];
    const {menuLabel, methodName, menuTitle} = example;

   //console.log("DIR NUM EXAMPLE ",{dirNum, menuLabel, methodName, example, exampleIndex},e);

    this.codePlaygroundNav$SendRoutePayload(menuLabel, methodName, menuTitle);

  }

  static codePlaygroundNav$SendRoutePayload(menuLabel, methodName, menuTitle){
    const container = menuLabel;
    const exampleTitle = menuTitle;
    const defaultObj =    {
      "pageId": "docs",
      "stage": "examples",
      "channel": "ROUTE",
      "section": "",
      "topic": "",
      "subtopic": "",
      "eventPreventDefault": "true",
      "isMenuLink": "true",
      "codeBlockId": "define",
      "codeBlockDataSection": "types",
    }

    const payload = {container, exampleTitle, methodName, ...defaultObj};

    const channelName = "CHANNEL_ROUTE";
    this.sendInfoToChannel(channelName, payload);
  }
}
